// 🧭 Navigation - Composant principal de navigation responsive
// Gère l'affichage conditionnel selon la taille d'écran
// Utilisé dans : src/App.jsx (routes principales)

import DesktopNav from './DesktopNav'
import MobileHeader from './MobileHeader'
import BottomNav from './BottomNav'

/**
 * Navigation principale - Gère l'affichage responsive de la navigation
 * Architecture responsive :
 * - Desktop: Menu complet en haut avec liens directs
 * - Mobile: Header simple en haut + Bottom Nav en bas (style app mobile)
 * 
 * @param {Object} props
 * @param {boolean} props.darkMode - État du thème sombre
 * @param {Function} props.toggleDarkMode - Fonction pour basculer le thème
 */
export default function Navigation({ darkMode, toggleDarkMode }) {
  return (
    <>
      {/* Navigation Desktop - Visible uniquement sur écrans larges */}
      <DesktopNav 
        darkMode={darkMode} 
        toggleDarkMode={toggleDarkMode}
      />
      
      {/* Navigation Mobile Header - Visible uniquement sur mobile */}
      <MobileHeader 
        darkMode={darkMode} 
        toggleDarkMode={toggleDarkMode} 
      />
      
      {/* Navigation Mobile Bottom - Navigation inférieure style app */}
      <BottomNav />
    </>
  )
}
